import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ customertypelist, setCustoemrtype, customertype, setCustoemrName,
    customername, setMobile, mobile,
    customergrplist, setcustomerGrp, customergrp,
    terilist, terittory, setTerittory,
    setlead, lead, leadlist,
    setAccount, account, accountlist,
    isGroup, setIsGroup,
    setCurrency, currency, currencylist,
    price, setPrice, pricelist,
    setBankAccount, bankAccount, banklist,
    setMarket, market, marketList,
    industry, setIndustry, industrylist,
    website, setWebsite,
    customerDetails, setCustomerDetails
}) => {

 
    const status = 'no'
    return (

        <div>



            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                value={customername}
                                readOnly
                                onChange={(e) => setCustoemrName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                value={customertype}
                                readOnly
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Mobile"
                                label="Mobile"
                                value={mobile}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input

                                label="Customer Group"
                                value={customergrp}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-4 ">
                    <div className="mb-3">
                        <Input

                            label="Territory"
                            value={terittory}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />
                    </div>
                </div>

                <div className="col-4">
                    <div className="mb-3">
                        <Input
                            label="From Lead"
                            value={lead}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />
                        {/* <SelectSearch
                        list={leadlist}
                        label="From Lead"
                        value={lead}
                        onChange={(val) => setlead(val)}
                        getOptionLabel={(item) => item.name}
                        getOptionValue={(item) => item.name}
                        placeholder=" "
                    /> */}
                    </div>
                </div>
                <div className="col-4">
                    <div className="mb-3">
                        <Input
                            label="Account Manager"
                            value={account}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />
                    </div>
                </div>
            </div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Defaults</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Billing Currency"
                                value={currency}
                                readOnly

                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Default Company Bank Account"
                                value={bankAccount}
                                readOnly

                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Default Price List"
                                value={price}
                                readOnly

                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>

                <div className=' mb-3 mx-3' style={{ display: 'flex', gap: '1rem', gap: '130px' }}>
                    <div>
                        <input
                            type="checkbox"
                            id="defaultCheck"
                            className="form-check-input mt-2"
                            style={{ width: '12px', height: '12px' }}
                            checked={isGroup === 1}
                            onChange={(e) => setIsGroup(e.target.checked ? 1 : 0)}
                        />
                        <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem', fontSize: '10px', color: '#00000099' }}>Is Internal Customer</label>
                    </div>
                </div>


            </div>

            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">More Information </p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Industry Type"
                                value={industry}
                                readOnly

                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Market Segment"
                                value={market}
                                readOnly

                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Website"
                                readOnly
                                style={{ height: "30px" }}
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='mt-2 mb-3' style={{ display: 'flex', gap: '1rem', gap: '130px' }}>
                    <div>
                        <Textarea
                            id="BrandDescription"
                            label="Description"
                            readOnly={status}
                            style={{ whiteSpace: 'pre-wrap', backgroundColor: '#f8f6f6', width: '655px' }}
                            value={customerDetails}
                            onChange={(e) => setCustomerDetails(e.target.value)}
                        />
                        {/* <Textarea

                        label={"Customer Details"}
                        style={{ width: '655px' }}
                        value={customerDetails}
                        readOnly={status}
                        onChange={(e) => setCustomerDetails(e.target.value)}

                    /> */}
                    </div>
                </div>
                <div className='mx-2' style={{ fontSize: '10px', color: '#00000099' }}>
                    <p>Additional information regarding the customer.</p>
                </div>

            </div>
                 <div className="">
                <ActivityCard doctype="Customer" docname={customername} />
            </div>


        </div>
    )
}

export default Tab1